/* Silk Scarfs - coque : tiroirs (menu, recherche, panier) + panier AJAX.
   Repli sans JavaScript : le MENU et la RECHERCHE s'ouvrent par :target (<a href="#ss-menu">) et se
   ferment par <a href="#">. Le PANIER n'a pas de tiroir sans JS : son icone est un vrai lien vers
   /cart et la page panier fait le travail. A l'interieur du tiroir, les pas de quantite et le retrait
   restent de vrais liens /cart/change et le paiement un submit, pour ne jamais dependre du JS. */
(function () {
  'use strict';

  /* les deux sections peuvent reclamer le script : une seule instance doit poser les ecouteurs */
  if (window.__ssShell) return;
  window.__ssShell = true;

  var root = document.documentElement;
  var openPanelEl = null;
  var opener = null;
  var lastAdded = null;
  var animateKey = null; // article a faire glisser en place a la prochaine mise a jour du tiroir
  var pendingFocus = null;
  var IDS = { cart: 'ss-cart', menu: 'ss-menu', search: 'ss-search' };
  var HASHED = [IDS.menu, IDS.search];

  root.classList.add('ss-js');

  function byId(id) { return document.getElementById(id); }

  function focusables(el) {
    var list = el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]');
    return Array.prototype.filter.call(list, function (n) {
      if (n.tabIndex < 0) return false;                        // le voile est en tabindex="-1"
      if (n.closest('[aria-hidden="true"]')) return false;
      return n.offsetWidth > 0 || n.offsetHeight > 0;
    });
  }

  function clearHash() {
    if (!location.hash) return;
    var h = location.hash.slice(1);
    if (HASHED.indexOf(h) === -1 && h !== IDS.cart) return;
    history.replaceState(null, '', location.pathname + location.search);
  }

  /* la page ne doit pas glisser de la largeur de la barre de defilement quand on la verrouille */
  function lockScroll(on) {
    if (on) {
      var gap = window.innerWidth - root.clientWidth;
      root.style.setProperty('--ss-lock-gap', (gap > 0 ? gap : 0) + 'px');
      root.classList.add('ss-lock');
    } else {
      root.classList.remove('ss-lock');
      root.style.removeProperty('--ss-lock-gap');
    }
  }

  function setInert(on) {
    var main = byId('MainContent');
    if (!main) return;
    if (on) { main.setAttribute('inert', ''); } else { main.removeAttribute('inert'); }
  }

  function show(id, from) {
    var p = byId(id);
    if (!p) return false;
    if (openPanelEl && openPanelEl !== p) hide(true);
    clearHash();
    opener = from || document.activeElement;
    p.classList.add('is-open');
    lockScroll(true);
    setInert(true);
    openPanelEl = p;
    var f = p.querySelector('[data-ss-focus]') || focusables(p)[0];
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    document.addEventListener('keydown', onKey, true);
    return true;
  }

  function hide(quiet) {
    clearHash();
    var any = document.querySelectorAll('.ss-drawer.is-open');
    if (!any.length && !openPanelEl) return;
    Array.prototype.forEach.call(any, function (d) { d.classList.remove('is-open'); });
    openPanelEl = null;
    lockScroll(false);
    setInert(false);
    document.removeEventListener('keydown', onKey, true);
    if (!quiet && opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    opener = null;
  }

  function onKey(e) {
    if (!openPanelEl) return;
    if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(openPanelEl);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- panier ---------- */

  function sectionId() {
    var el = document.querySelector('[data-ss-cart-section]');
    return el ? el.getAttribute('data-ss-cart-section') : null;
  }

  function rootUrl() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root;
    return r ? r.replace(/\/$/, '') : '';
  }

  function setCount(n) {
    var txt = String(n);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-cart-count]'), function (b) {
      b.textContent = txt;
      b.hidden = n === 0;
    });
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var target = null;
    Array.prototype.forEach.call(bubble.querySelectorAll('span, div'), function (d) {
      if (!d.children.length && /^\s*\d+\s*$/.test(d.textContent)) target = d;
    });
    if (!target) return;
    target.textContent = txt;
    var holder = target.parentElement;
    if (holder && holder !== bubble) holder.hidden = n === 0;
  }

  function markAdded() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-new]'), function (b) { b.hidden = true; });
    if (!lastAdded) { animateKey = null; return; }
    var line = document.querySelector('[data-ss-key="' + lastAdded.replace(/"/g, '\\"') + '"]');
    if (!line) { lastAdded = null; animateKey = null; return; }
    var badge = line.querySelector('[data-ss-new]');
    if (badge) badge.hidden = false;
    /* juste ajoute (pas un simple changement de quantite) : la ligne glisse en place et s'eclaire,
       et la liste defile jusqu'a elle si elle est hors de vue */
    if (animateKey && animateKey === lastAdded) {
      line.classList.add('is-new');
      var box = line.closest('.ss-cart__scroll');
      if (box) {
        var dy = line.getBoundingClientRect().top - box.getBoundingClientRect().top;
        if (dy < 0 || dy > box.clientHeight - 60) box.scrollTop += dy - 8;
      }
    }
    animateKey = null;
  }

  function restoreFocus() {
    if (!pendingFocus) return;
    var line = '[data-ss-key="' + pendingFocus.key.replace(/"/g, '\\"') + '"]';
    /* on vise le SENS du bouton : sa valeur data-ss-step change a chaque pas */
    var el = document.querySelector(line + ' [data-ss-dir="' + pendingFocus.dir + '"]');
    if (!el) el = document.querySelector(line + ' [data-ss-dir]');
    if (!el) {
      var p = byId(IDS.cart);
      el = p && (p.querySelector('.ss-cart__x') || focusables(p)[0]);
    }
    if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    pendingFocus = null;
  }

  function applySections(sections) {
    var id = sectionId();
    if (!id || !sections || !sections[id]) return false;
    var doc = new DOMParser().parseFromString(sections[id], 'text/html');
    var fresh = doc.querySelector('[data-ss-cart-inner]');
    var cur = document.querySelector('[data-ss-cart-inner]');
    if (!fresh || !cur) return false;
    cur.innerHTML = fresh.innerHTML;
    var holder = doc.querySelector('[data-ss-count]');
    setCount(holder ? parseInt(holder.getAttribute('data-ss-count'), 10) || 0 : 0);
    markAdded();
    restoreFocus();
    return true;
  }

  function busy(on) {
    var p = byId(IDS.cart);
    if (p) p.classList.toggle('is-busy', !!on);
  }

  function sectionsUrl(id) {
    var q = location.search ? location.search + '&' : '?';
    return location.pathname + q + 'sections=' + encodeURIComponent(id);
  }

  function fetchSections() {
    var id = sectionId();
    if (!id) return Promise.resolve(false);
    /* pas d'en-tete Accept: sur une URL produit il ferait renvoyer le JSON du produit au lieu des sections */
    return fetch(sectionsUrl(id))
      .then(function (r) { return r.json(); })
      .then(function (j) { return applySections(j); })
      .catch(function () { return false; });
  }

  function change(key, qty, from) {
    var id = sectionId();
    var payload = { id: key, quantity: qty };
    if (id) payload.sections = id;
    busy(true);
    fetch(rootUrl() + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        busy(false);
        if (qty === 0 && lastAdded === key) lastAdded = null;
        if (!applySections(d.sections)) return fetchSections();
      })
      .catch(function () {
        busy(false);
        location.href = (from && from.getAttribute && from.getAttribute('href')) || (rootUrl() + '/cart');
      });
  }

  function fail(form, msg) {
    var box = form.querySelector('[data-ss-error]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
    if (msg) box.focus();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented) return; // ss-product.js et ss-collection.js gerent deja leur ajout
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var id = sectionId();
    var fd = new FormData(form);
    if (id) fd.append('sections', id);
    form.classList.add('is-busy');
    fail(form, '');
    fetch(rootUrl() + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        form.classList.remove('is-busy');
        if (d.status) { fail(form, d.description || d.message); return; }
        lastAdded = d.key || (d.items && d.items[0] && d.items[0].key) || null;
        animateKey = lastAdded;
        var p = byId(IDS.cart);
        if (p) p.setAttribute('data-ss-added', 'true');
        if (!applySections(d.sections)) fetchSections();
        show(IDS.cart, form);
      })
      .catch(function () { form.classList.remove('is-busy'); location.href = rootUrl() + '/cart'; });
  });

  /* ---------- clics ---------- */

  var CART_RE = /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?(\?|$)/i;

  function forgetAdded() {
    var c = byId(IDS.cart);
    if (c) c.removeAttribute('data-ss-added');
    lastAdded = null;
    markAdded();
  }

  /* phase de CAPTURE : le JS d'Ella annule le clic sur son icone panier avant nous */
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-ss-close]')) { e.preventDefault(); hide(); return; }

    var o = t.closest('[data-ss-open]');
    if (o) {
      var id = o.getAttribute('data-ss-open');
      if (id === IDS.cart) forgetAdded();
      if (show(id, o)) e.preventDefault();
      return;
    }

    var rm = t.closest('[data-ss-remove]');
    if (rm) { e.preventDefault(); pendingFocus = null; change(rm.getAttribute('data-ss-remove'), 0, rm); return; }

    var step = t.closest('[data-ss-step]');
    if (step) {
      e.preventDefault();
      var q = parseInt(step.getAttribute('data-ss-step'), 10);
      var key = step.getAttribute('data-ss-key');
      if (isNaN(q) || q < 0 || !key) return;
      pendingFocus = { key: key, dir: step.getAttribute('data-ss-dir') || 'up' };
      change(key, q, step);
      return;
    }

    var link = t.closest('a[href]');
    if (link && !link.hasAttribute('data-ss-no-drawer') && CART_RE.test(link.getAttribute('href') || '')) {
      forgetAdded();
      if (show(IDS.cart, link)) { e.preventDefault(); e.stopPropagation(); }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.hasAttribute) return;
    if (input.hasAttribute('data-ss-input')) {
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      pendingFocus = null;
      change(input.getAttribute('data-ss-key'), q, null);
      return;
    }
    /* repli des onglets du menu pour les navigateurs sans :has() */
    if (input.name === 'ss-menu-tab') {
      var nav = document.querySelector('.ss-menu__nav');
      if (nav) nav.setAttribute('data-tab', input.value);
    }
  });

  /* point d'entree pour ss-product.js et ss-collection.js, qui font leur propre /cart/add.js */
  window.SSShell = {
    open: function (id, from) { return show(id || IDS.cart, from); },
    close: hide,
    refresh: fetchSections,
    sectionId: sectionId,
    added: function (payload) {
      var d = payload || {};
      lastAdded = d.key || (d.items && d.items[0] && d.items[0].key) || null;
      animateKey = lastAdded;
      var p = byId(IDS.cart);
      if (p) p.setAttribute('data-ss-added', 'true');
      var done = (d.sections && applySections(d.sections)) ? Promise.resolve(true) : fetchSections();
      return done.then(function () { show(IDS.cart, null); });
    }
  };

  /* arrive sur une URL portant #ss-menu : on reprend la main et on retire le fragment,
     sinon :target garderait le tiroir ouvert et son voile avalerait tous les clics */
  if (location.hash) {
    var h0 = location.hash.slice(1);
    if (HASHED.indexOf(h0) !== -1) {
      history.replaceState(null, '', location.pathname + location.search);
      show(h0, null);
    } else if (h0 === IDS.cart) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }
})();

/* Titres Bodoni : le W n'a AUCUNE paire de crénage dans Bodoni Moda (V et Y en ont une de -11 %),
   d'où le trou de « W ashing ». On rapproche le W de la minuscule qui suit, dans les seuls textes
   en Bodoni ; le texte reste le même (un span autour de la lettre), rien ne change pour le SEO. */
(function () {
  'use strict';
  var SEL = 'h1,h2,h3,h4,h5,h6,blockquote,[class*="title"],[class*="heading"],[class*="__name"],[class*="__label"],[class*="__num"]';
  function kern(root) {
    var els = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-ss-kern') || el.textContent.indexOf('W') < 0) continue;
      if (!/Bodoni/i.test(window.getComputedStyle(el).fontFamily)) continue;
      el.setAttribute('data-ss-kern', '1');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) { if (/W[a-z]/.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode); }
      nodes.forEach(function (node) {
        var parts = node.nodeValue.split(/(W(?=[a-z]))/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part, idx) {
          if (part === 'W' && idx % 2 === 1) {
            var next = parts[idx + 1] ? parts[idx + 1].charAt(0) : '';
            var s = document.createElement('span');
            /* devant une lettre haute (h, l, k, b, t, f) le vide est moindre */
            s.className = /[hlkbtfd]/.test(next) ? 'ss-kw ss-kw--tall' : 'ss-kw';
            s.textContent = 'W';
            frag.appendChild(s);
          } else if (part) {
            frag.appendChild(document.createTextNode(part));
          }
        });
        node.parentNode.replaceChild(frag, node);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kern(); });
  else kern();
  /* sections rechargees par l'editeur de theme ou par le tiroir panier */
  document.addEventListener('shopify:section:load', function (e) { kern(e.target); });
})();

/* ============================================================================
   Menus de l'en-tête (29/09) — un seul contrôleur pour tous les navigateurs.
   Ella : ouverture après 0,2 s puis glissé de -20 % sur 0,6 s, fermeture au premier pixel de sortie,
   aucune ouverture au clavier (Entrée ET Espace naviguent), aucun survol sur un écran tactile de
   bureau, et sous Safari (qui ignore les éléments intégrés personnalisés « is= ») un repli qui ouvre
   sans délai et laisse details[open="false"]. details-disclosure.js laisse désormais ces menus-ci à ce
   fichier (repli Safari coupé pour .header__inline-menu).
   - Survol : ouverture en 70 ms. Si un AUTRE menu est ouvert, on ne bascule que lorsque la souris
     s'arrête 170 ms sur le nouveau titre : une diagonale qui traverse « Info » ne bascule jamais.
     Fermeture après 260 ms, 650 ms si la souris descend encore vers le panneau (bande vide de l'en-tête).
   - Clavier : Espace / Flèche bas ouvrent et donnent le focus au 1er lien ; Entrée va à la collection ;
     Échap referme et rend le focus au titre.
   - Toucher (écran tactile ≥ 1025 px) : 1er toucher ouvre, 2e navigue.
   - Voile sous le grand panneau (CSS par :has()), aperçu au survol dans la 1re carte photo.
   ========================================================================== */
(function () {
  'use strict';
  var MENU = '.header__inline-menu';
  var ptr = { x: 0, y: 0, dy: 0, type: 'mouse' };
  document.addEventListener('mousemove', function (e) { ptr.dy = e.clientY - ptr.y; ptr.x = e.clientX; ptr.y = e.clientY; }, { passive: true });
  document.addEventListener('pointerdown', function (e) { ptr.type = e.pointerType || 'mouse'; }, true);

  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function desktop() { return window.innerWidth >= 1025; }
  function menus() { return [].slice.call(document.querySelectorAll(MENU + ' details')); }
  function upgraded(d) { return typeof DropdownDetails !== 'undefined' && d instanceof DropdownDetails; }
  function ready(d) { return !upgraded(d) || !!d.elements; }
  function isOpen(d) { return upgraded(d) ? !!d.isOpen : (d.hasAttribute('open') && d.getAttribute('open') !== 'false'); }

  function fadeIn(dd) {
    var r = reduced();
    if (typeof Motion === 'undefined') { dd.style.opacity = '1'; dd.style.visibility = 'visible'; return Promise.resolve(); }
    Motion.animate(dd, { opacity: [0, 1], visibility: 'visible', overflow: 'visible' }, { duration: r ? 0 : 0.18, easing: [0.2, 0, 0.2, 1] });
    if (!dd.firstElementChild) return Promise.resolve();
    return Motion.animate(dd.firstElementChild, { transform: ['translateY(-6px)', 'translateY(0)'] }, { duration: r ? 0 : 0.24, easing: [0.2, 0, 0.2, 1] }).finished;
  }
  function fadeOut(dd) {
    var r = reduced();
    if (typeof Motion === 'undefined') { dd.style.opacity = '0'; dd.style.visibility = 'hidden'; return Promise.resolve(); }
    if (dd.firstElementChild) Motion.animate(dd.firstElementChild, { transform: 'translateY(-4px)' }, { duration: r ? 0 : 0.14, easing: [0.4, 0, 1, 1] });
    return Motion.animate(dd, { opacity: 0, visibility: 'hidden', overflow: 'hidden' }, { duration: r ? 0 : 0.14, easing: [0.4, 0, 1, 1] }).finished;
  }

  /* Safari et tout navigateur où l'élément n'est pas « amélioré » : ouverture/fermeture maison */
  function setOpen(d, open) {
    if (upgraded(d)) { if (d.elements) d.isOpen = open; return; }
    var dd = d.querySelector('.details__list');
    var sum = d.querySelector('summary');
    if (!dd) return;
    var tok = (d.__ssTok = (d.__ssTok || 0) + 1);
    if (open) {
      d.setAttribute('open', 'true');
      if (sum) sum.setAttribute('aria-expanded', 'true');
      fadeIn(dd);
    } else {
      if (sum) sum.setAttribute('aria-expanded', 'false');
      var done = function () { if (d.__ssTok === tok) d.removeAttribute('open'); };
      fadeOut(dd).then(done, done);
    }
  }
  function closeOthers(d) {
    menus().forEach(function (o) { if (o !== d && isOpen(o)) { clearTimeout(o.__ssT); setOpen(o, false); } });
  }
  function stopRest(d) { if (d.__ssRest) { d.removeEventListener('mousemove', d.__ssRest); d.__ssRest = null; } }

  function enter(d) {
    clearTimeout(d.__ssT);
    stopRest(d);
    if (!ready(d) || isOpen(d)) return;
    var others = menus().filter(function (o) { return o !== d && isOpen(o); });
    if (!others.length) {
      d.__ssT = setTimeout(function () { setOpen(d, true); }, 70);
      return;
    }
    var arm = function () {
      clearTimeout(d.__ssT);
      var still = menus().some(function (o) { return o !== d && isOpen(o); });
      d.__ssT = setTimeout(function () { stopRest(d); closeOthers(d); setOpen(d, true); }, still ? 170 : 70);
    };
    d.__ssRest = arm;
    d.addEventListener('mousemove', arm, { passive: true });
    arm();
  }
  function leave(d) {
    clearTimeout(d.__ssT);
    stopRest(d);
    if (!isOpen(d)) return;
    var dd = d.querySelector('.details__list');
    var top = dd ? dd.getBoundingClientRect().top : 0;
    var towardPanel = ptr.dy > 0 && ptr.y < top;
    d.__ssT = setTimeout(function () { setOpen(d, false); }, towardPanel ? 650 : 260);
  }

  /* Ella : son survol, ses fondus et son clic extérieur (classe inexistante) sont remplacés pour ces menus */
  function patchElla() {
    if (typeof DropdownDetails === 'undefined') return;
    var P = DropdownDetails.prototype;
    if (P.__ssPatched) return;
    P.__ssPatched = true;
    var oHover = P.onHover, oIn = P.transitionIn, oOut = P.transitionOut, oOutside = P.onClickOutside;
    var mine = function (el) { return !!(el && el.closest && el.closest(MENU)); };
    P.onHover = function (e) { if (!mine(this)) return oHover.call(this, e); };
    P.transitionIn = function () { if (!mine(this) || !this.elements || !this.elements.dropdown) return oIn.call(this); return fadeIn(this.elements.dropdown); };
    P.transitionOut = function () { if (!mine(this) || !this.elements || !this.elements.dropdown) return oOut.call(this); return fadeOut(this.elements.dropdown); };
    P.onClickOutside = function (e) {
      if (!mine(this)) return oOutside.call(this, e);
      if (!this.contains(e.target)) this.isOpen = false;
    };
  }

  function bind() {
    menus().forEach(function (d) {
      if (d.__ssBound) return;
      d.__ssBound = true;
      d.addEventListener('mouseenter', function () { if (ptr.type === 'mouse' && desktop()) enter(d); });
      d.addEventListener('mouseleave', function () { if (ptr.type === 'mouse' && desktop()) leave(d); });
      if (!upgraded(d)) {
        d.addEventListener('focusout', function (e) { if (e.relatedTarget && !d.contains(e.relatedTarget) && isOpen(d)) setOpen(d, false); });
      }
    });
  }

  function summaryOf(t) { return t && t.closest ? t.closest(MENU + ' details > summary') : null; }
  function firstLink(d) { return d.querySelector('.details__list a[href], .details__list button'); }
  function hrefOf(sum) { var h = sum.querySelector('[data-href]'); return h ? h.getAttribute('data-href') : ''; }

  document.addEventListener('keydown', function (e) {
    var sum = summaryOf(e.target);
    if (sum) {
      var d = sum.parentElement;
      if (!d || !ready(d)) return;
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        sum.__ssSwallow = true;
        setTimeout(function () { sum.__ssSwallow = false; }, 600);
        closeOthers(d);
        if (!isOpen(d)) setOpen(d, true);
        setTimeout(function () { var a = firstLink(d); if (a) a.focus(); }, 40);
        return;
      }
      if (e.key === 'Enter' && !upgraded(d) && hrefOf(sum)) {
        e.preventDefault();
        window.location.assign(hrefOf(sum));
        return;
      }
    }
    if (e.key === 'Escape') {
      var open = e.target && e.target.closest ? e.target.closest(MENU + ' details') : null;
      if (open && isOpen(open)) {
        var s = open.querySelector('summary');
        setTimeout(function () { if (isOpen(open)) setOpen(open, false); if (s) s.focus(); }, 0);
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    var sum = summaryOf(e.target);
    if (sum && sum.__ssSwallow) { sum.__ssSwallow = false; e.preventDefault(); e.stopPropagation(); return; }
    if (sum) {
      var d = sum.parentElement;
      if (!d || !ready(d)) return;
      if ((ptr.type === 'touch' || ptr.type === 'pen') && desktop() && !isOpen(d)) {
        e.preventDefault();
        e.stopPropagation();
        closeOthers(d);
        setOpen(d, true);
        return;
      }
      /* Safari (élément non amélioré) : un clic de souris va à la collection, comme ailleurs */
      if (!upgraded(d) && hrefOf(sum)) {
        e.preventDefault();
        window.location.assign(hrefOf(sum));
      }
      return;
    }
    /* clic ailleurs : les menus maison se ferment (Ella gère les siens) */
    menus().forEach(function (d) { if (!upgraded(d) && isOpen(d) && !d.contains(e.target)) setOpen(d, false); });
  }, true);

  function addDim() {
    if (document.querySelector('.ss-mega-dim') || !document.querySelector('.ss-mc--dim')) return;
    var dim = document.createElement('div');
    dim.className = 'ss-mega-dim';
    dim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(dim);
  }

  /* photos des cartes : chargées dès la 1re interaction sur un écran de bureau (souris, clavier ou
     doigt), pour qu'elles soient là à l'ouverture ; jamais sous 1025 px, où ce menu est masqué */
  function warmImages() {
    if (!desktop()) return;
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      [].forEach.call(document.querySelectorAll(MENU + ' .ss-mc img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    };
    window.addEventListener('mousemove', run, { passive: true, once: true });
    window.addEventListener('touchstart', run, { passive: true, once: true });
    document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest(MENU)) run(); });
  }

  /* Aperçu : il faut RESTER 120 ms sur un lien (le frôler en allant vers la carte ne compte pas) ;
     un lien qui mène déjà à l'autre carte photo n'est pas aperçu ; la carte revient à son état quand
     on quitte le panneau, quand le focus en sort ou quand le panneau se ferme. */
  function initPreview(root) {
    [].forEach.call((root || document).querySelectorAll('.ss-mc--pv'), function (mc) {
      if (mc.__ssPv) return;
      var card = mc.querySelector('[data-ss-pv-card]');
      if (!card) return;
      mc.__ssPv = true;
      var img = card.querySelector('.ss-mc__feat-media img');
      var tEl = card.querySelector('.ss-mc__feat-label');
      var mEl = card.querySelector('.ss-mc__feat-meta');
      var def = { href: card.getAttribute('href'), src: img ? img.getAttribute('src') : '', set: img ? img.getAttribute('srcset') : '', t: tEl ? tEl.textContent : '', m: mEl ? mEl.textContent : '' };
      var others = [].slice.call(mc.querySelectorAll('.ss-mc__feat')).filter(function (f) { return f !== card; }).map(function (f) { return f.getAttribute('href'); });
      var current = def;
      var timer = 0;
      function show(d) {
        if (d === current) return;
        current = d;
        card.setAttribute('href', d.href);
        if (tEl) tEl.textContent = d.t;
        if (mEl) { mEl.textContent = d.m || ''; mEl.hidden = !d.m; }
        if (img && d.src) {
          if (d.set) { img.setAttribute('srcset', d.set); } else { img.removeAttribute('srcset'); }
          img.setAttribute('src', d.src);
        }
        card.classList.toggle('is-preview', d !== def);
      }
      function fromLink(a) { return { href: a.getAttribute('href'), src: a.getAttribute('data-ss-pv'), set: a.getAttribute('data-ss-pv-set'), t: a.getAttribute('data-ss-pv-t'), m: a.getAttribute('data-ss-pv-m') }; }
      function linkOf(t) { var a = t && t.closest ? t.closest('a[data-ss-pv]') : null; return a && mc.contains(a) ? a : null; }
      function enterLink(a) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var d = fromLink(a);
          if (!d.src || others.indexOf(d.href) > -1 || (current && current.href === d.href)) return;
          if (!img) { show(d); return; }
          var pre = new Image();
          if (img.sizes) pre.sizes = img.sizes;
          if (d.set) pre.srcset = d.set;
          pre.src = d.src;
          var fired = false;
          var go = function () { if (fired) return; fired = true; show(d); };
          if (pre.decode) { pre.decode().then(go, go); } else { pre.onload = go; pre.onerror = go; }
          setTimeout(go, 400);
        }, 120);
      }
      mc.addEventListener('mouseover', function (e) { var a = linkOf(e.target); if (a) enterLink(a); });
      mc.addEventListener('mouseout', function (e) { var a = linkOf(e.target); if (a && !a.contains(e.relatedTarget)) clearTimeout(timer); });
      mc.addEventListener('focusin', function (e) { var a = linkOf(e.target); if (a) enterLink(a); });
      mc.addEventListener('focusout', function (e) { if (!e.relatedTarget || !mc.contains(e.relatedTarget)) { clearTimeout(timer); show(def); } });
      mc.addEventListener('mouseleave', function () { clearTimeout(timer); show(def); });
      var det = mc.closest('details');
      if (det && window.MutationObserver) {
        new MutationObserver(function () { if (!isOpen(det)) { clearTimeout(timer); show(def); } }).observe(det, { attributes: true, attributeFilter: ['open'] });
      }
    });
  }

  function boot(root) {
    patchElla();
    bind();
    addDim();
    initPreview(root);
  }
  patchElla();
  warmImages();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('section:cached', function () { setTimeout(function () { bind(); addDim(); initPreview(document); }, 0); });
  document.addEventListener('shopify:section:load', function (e) { bind(); addDim(); initPreview(e.target); });
})();
